module.exports = __webpack_public_path__ + "static/media/integrate-freelancers-banner-image.aff1f0e3.webp";